"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _Loading = _interopRequireDefault(require("../components/Loading/Loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var config = {
  containers: {
    AppContainer: (0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../containers/AppContainer/AppContainer'));
      });
    }),
    LayoutContainer: (0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../containers/LayoutContainer/LayoutContainer'));
      });
    })
  },
  components: {
    Loading: _Loading.default,
    Menu: (0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../containers/Menu/Menu'));
      });
    })
  },
  pwa: {
    useiOSPWAPrompt: true,
    iOSPWAPromptProps: {}
  },
  menu: {
    width: 240,
    offlineIndicatorHeight: 12,
    initialAuthMenuOpen: false,
    initialMiniMode: false,
    initialMenuOpen: true,
    initialMobileMenuOpen: false,
    initialMiniSwitchVisibility: true,
    MenuHeader: (0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../components/MenuHeader/MenuHeader'));
      });
    }),
    useWindowWatcher: false
  },
  pages: {
    LandingPage: (0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../pages/LandingPage/LandingPage'));
      });
    }),
    PageNotFound: (0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../pages/PageNotFound/PageNotFound'));
      });
    })
  },
  update: {
    checkInterval: 3000,
    repeatInterval: 300000
  }
};
var _default = config;
exports.default = _default;
module.exports = exports.default;